import { render, staticRenderFns } from "./enterprise-archives.vue?vue&type=template&id=38c0a1a0&scoped=true"
import script from "./enterprise-archives.vue?vue&type=script&lang=js"
export * from "./enterprise-archives.vue?vue&type=script&lang=js"
import style0 from "./enterprise-archives.vue?vue&type=style&index=0&id=38c0a1a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c0a1a0",
  null
  
)

export default component.exports